import { Fragment, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { setTotalPrice } from '../actions/checkout-la-actions'
import { CheckoutSuccess, ShopBanner, Steps } from '../components/checkout'
import useStep from '../components/checkout-la/hooks/useStep'
import Step1 from '../components/checkout-la/Step1'
import Step2 from '../components/checkout-la/Step2'
import Step3 from '../components/checkout-la/Step3'
import LegacyStep4 from '../components/checkout-la/Step4'
import RedesignStep4 from '../components/checkout-la/redesign/Step4/Step4'
import { parseQuery } from '../utils'
import Loader from '../components/helpers/Loader'
import { trackEvent } from '../gtm'

const steps = [
  {
    text: (
      <FormattedMessage
        id='select_your_trip'
        defaultMessage='Select your trip'
      />
    ),
    shortText: <FormattedMessage defaultMessage='Trip' />,
  },
  {
    text: (
      <FormattedMessage
        id='select_your_cabin'
        defaultMessage='Select your cabin'
      />
    ),
    shortText: <FormattedMessage id='cabin' defaultMessage='Cabin' />,
  },
  {
    text: <FormattedMessage id='add_extras' defaultMessage='Add Extras' />,
    shortText: <FormattedMessage id='extras' defaultMessage='Extras' />,
  },
  {
    text: <FormattedMessage id='review_book' defaultMessage='Review & book' />,
    shortText: <FormattedMessage id='review' defaultMessage='Review' />,
  },
]

const params = parseQuery()
const isRedesign = params.version === 'B'
const Step4 = isRedesign ? RedesignStep4 : LegacyStep4

export default function CheckoutLiveaboardPage({
  slug,
  countrySlug,
  id,
  title,
  url,
  background,
  currency,
  itinerariesLength,
  countryCode,
}) {
  const { step, setStep } = useStep()
  const [tripId, setTripId] = useState()
  const dispatch = useDispatch()
  const totalPrice = useSelector((state) => state.totalPrice)
  const isLoading = useSelector((state) => state.pageLoader)
  const [order, setOrder] = useState({})
  const openStep2 = (product) => {
    setTripId(product.id)
    setStep(2)
  }

  useEffect(() => {
    trackEvent({
      page_content_type: 'Travel - Vacations - Booking',
      business_type: 'Liveaboard',
      business_id: id,
      business_slug: slug,
      business_country_slug: countrySlug,
    })
  }, [])

  useEffect(() => {
    if(params.productId) {
      openStep2({ id: params.productId })
    }
  }, [params.productId])

  useEffect(() => {
    if(step < 3 && totalPrice) {
      dispatch(setTotalPrice(null))
    }
  }, [step, totalPrice])

  const StepContent = useMemo(() => {
    if(step === 1) {
      return (
        <Step1
          slug={slug}
          countrySlug={countrySlug}
          id={id}
          currency={currency}
          itinerariesLength={itinerariesLength}
          onSelect={openStep2}
        />
      )
    }
    if(step === 2) {
      return <Step2 tripId={tripId} />
    }
    if(step === 3) {
      return <Step3 />
    }
    if(step === 4) {
      return <Step4 tripId={tripId} setOrder={setOrder} countryCode={countryCode} url={url} />
    }
  }, [step])

  return (
    <Fragment>
      <Loader isLoading={isLoading} fixed size='big' />
      {step === 5 ? (
        <div>

          <div className='checkout-wrapper'>
            <CheckoutSuccess order={order} kind={10} />
          </div>
        </div>
      ) : step === 4 && isRedesign ? (
        <div>
          {StepContent}
        </div>
      ) : (
        <div>
          <ShopBanner title={title} url={url} image={background} />
          <Steps
            steps={steps}
            currentStep={step}
            currency={currency}
            setStep={setStep}
            totalPrice={totalPrice}
            showPrice
          />
          <div className='checkout-wrapper'>
            <div className='content'>{StepContent}</div>
          </div>
        </div>
      )}
    </Fragment>
  )
}

CheckoutLiveaboardPage.propTypes = {
  slug: PropTypes.string,
  countrySlug: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  url: PropTypes.string,
  background: PropTypes.string,
  currency: PropTypes.string,
  itinerariesLength: PropTypes.number,
  countryCode: PropTypes.string,
}
